import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const hotArticles = [...articles].sort((a, b) => b.hotScore - a.hotScore).slice(0, 8);

function getHotLabel(score: number) {
  if (score >= 95) return { text: '沸', color: 'bg-red-500' };
  if (score >= 85) return { text: '热', color: 'bg-primary-500' };
  return { text: '新', color: 'bg-accent-500' };
}

function formatViews(views: number) {
  if (views >= 100000) return `${(views / 10000).toFixed(0)}万阅`;
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万阅`;
  return `${views}阅`;
}

export default function HotGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              51每日大赛热门榜单
            </h2>
            <p className="text-sm text-foreground-500 mt-2 font-label">
              实时更新全网吃瓜爆料与黑料视频
            </p>
          </div>
          <Link to="/category/shishi-baoliao" className="text-sm text-primary-500 hover:text-primary-600 font-label whitespace-nowrap flex items-center gap-1">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotArticles.map((article) => {
            const hotLabel = getHotLabel(article.hotScore);
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group relative rounded-2xl overflow-hidden aspect-[4/5] bg-foreground-100"
              >
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 51吃瓜每日大赛`}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

                <span className={`absolute top-3 right-3 px-2.5 py-1 text-xs font-label font-medium text-white rounded-lg ${hotLabel.color}`}>
                  {hotLabel.text}
                </span>

                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-base font-heading font-bold text-white leading-snug mb-2 line-clamp-2 group-hover:text-primary-300 transition-colors">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-white/60">
                    <span>{article.category === 'mingxing-fanche' ? '明星翻车' : article.category === 'wanghong-tafang' ? '网红塌房' : article.category === 'qiye-neimu' ? '企业内幕' : article.category === 'shishi-baoliao' ? '实时爆料' : '黑料曝光'}</span>
                    <span>·</span>
                    <span>{formatViews(article.views)}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}